// import { analyticsCB } from "@/components/cart/cartAnalytics"

export const removeFromCart = (data = {}) => {
  /**
   * It removeFrom cart for pay load
   */
  const {
    lineItemId = "",
    quantity = 0,
    isBundle = false,
    isBundleParent = false,
    sku = "",
  } = data

  const bundlePayload = {
    action: "removeBundleItem",
    customLineItemId: lineItemId,
    sku,
  }

  const actions = [
    isBundleParent
      ? bundlePayload
      : {
          action: isBundle ? "removebundle" : "removeLineItem",
          lineItemId,
          quantity,
        },
  ]

  return actions
}

export const setRemoveCartPayload = (items = []) => {
  /**
   * It removeFrom cart for payload removeBundleItem
   */
  const actions = []

  items.forEach(item => {
    const {
      id = "",
      sku = "",
      quantity = 0,
      isComboSku = false,
      bundleParentId = "",
      parentBundleId = "",
      parentBundleSku = "",
      isBundleParent = false,
      isBundleChildItem = false,
    } = item

    const filteredIds = items
      .filter(item => item.id && item.id !== id)
      .map(item => item.id)

    const isChildItem = parentBundleSku && isBundleChildItem
    const lineItemId = bundleParentId || id
    const action =
      isComboSku || bundleParentId ? "removebundle" : "removeLineItem"
    // filtering out the combo sku items, to select only parent item if available
    if (
      !filteredIds.includes(bundleParentId) &&
      !parentBundleSku &&
      !isBundleParent
    ) {
      actions.push({
        action,
        lineItemId,
        quantity,
      })
    } else if ((!parentBundleSku && isBundleParent) || isChildItem) {
      const customLineItemId = isChildItem ? parentBundleId : id
      // Handle static bundles and bundle child items
      actions.push({
        action: "removeBundleItem",
        customLineItemId,
        sku: isChildItem ? parentBundleSku : sku,
      })
    }
  })

  return actions
}
